import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import messages from '../../../messages';
import ArticleBody from '../ArticleBody';
const Laughter = () => (
  <ArticleBody>
    <ArticleBody>
      <FormattedHTMLMessage tagName="p" {...messages.laughterBody} />
    </ArticleBody>
  </ArticleBody>
);

Laughter.propTypes = {};

export default Laughter;
